import PublicScreens from "./PublicScreens";

export default PublicScreens;